import { setToken, setUserId } from "@/helpers/localStorage";
import { useWallet, WalletType } from "@/providers/wallet";
import { Button } from "@/ui/button";
import Select, { DataProp } from "@/ui/select";
import WalletAddress from "@/ui/wallet-address";
import { displayWalletAddress } from "@/utils/wallet";
import { useWeb3Auth } from "@web3auth/modal-react-hooks";

import { useMemo } from "react";

const WalletSelect = ({
  className = "min-w-[6.875rem]",
  signInButtonClassName = "min-w-[6.875rem] font-semibold text-xs bg-red-500 hover:bg-red-600 text-white bg-red-500",
  selectedWalletType = undefined,
}: {
  className?: string;
  signInButtonClassName?: string;
  selectedWalletType?: WalletType;
}) => {
  const { web3Auth, isConnected, connect } = useWeb3Auth();
  const { setWallet } = useWallet();

  const { solanaAddresses, ethereumAddresses, currentWallet } = useWallet();

  const onLogin = async () => {
    await connect();
    if (!web3Auth) {
      return;
    }
    const { idToken } = await web3Auth.authenticateUser();
    setToken(idToken);
    const { email } = await web3Auth.getUserInfo();
    setUserId(email || "");
  };

  const handleWalletChange = ({ value }: DataProp) => {
    const walletEth = ethereumAddresses.find(
      ({ address }) => address === value,
    );
    if (walletEth) {
      setWallet(walletEth);
      return;
    }

    const walletSol = solanaAddresses.find(({ address }) => address === value);
    if (walletSol) {
      setWallet(walletSol);
    }
  };

  const data = useMemo(() => {
    // const ethereumAddressList = ethereumAddresses.map(({ address }) => {
    //   return {
    //     label: displayWalletAddress(address),
    //     value: address,
    //     component: <WalletAddress chainIcon="ethereum" address={address} />,
    //   };
    // });

    const solanaAddressList = solanaAddresses.map(({ address }) => {
      return {
        label: displayWalletAddress(address),
        value: address,
        component: <WalletAddress chainIcon="solana" address={address} />,
      };
    });

    let addresses: { component: JSX.Element; label: string; value: string }[] =
      [];

    if (!selectedWalletType) {
      addresses = solanaAddressList;
      // addresses = ethereumAddressList.concat(solanaAddressList);
    } else if (selectedWalletType === WalletType.ETH) {
      // addresses = ethereumAddressList;
      addresses = solanaAddressList;
    } else if (selectedWalletType === WalletType.SOL) {
      addresses = solanaAddressList;
    }

    return addresses.sort((a) => {
      if (a.value === currentWallet?.address) {
        return -1;
      }
      return 1;
    });
  }, [solanaAddresses, currentWallet, selectedWalletType]);

  return (
    <>
      {isConnected ? (
        currentWallet ? (
          <Select
            className={className}
            key={"wallet-select"}
            data={data}
            initValue={data[0]}
            radius="bigger"
            onChange={handleWalletChange}
          />
        ) : (
          <div />
        )
      ) : null}
      {!isConnected && (
        <Button
          activeStyle="sing-in-button"
          title="Sign in"
          hover={true}
          className={`${signInButtonClassName} bg-red-500`}
          enabled={true}
          onClick={() => {
            onLogin();
          }}
        />
      )}
    </>
  );
};

export default WalletSelect;
